import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { getGameRegistry, getGameEntry } from "../registry/game-registry.js";
import { GamePlayer } from "./GamePlayer.js";
function GameTestPage({ api, user }) {
  const [selectedGameId, setSelectedGameId] = useState(null);
  const [isSoundOn, setIsSoundOn] = useState(true);
  const games = useMemo(() => getGameRegistry(), []);
  const testUser = user ?? { nickname: "Tester", id: "test-user" };
  if (selectedGameId) {
    const entry = getGameEntry(selectedGameId);
    const title = entry ? entry.ko.name : selectedGameId;
    return /* @__PURE__ */ jsxs("div", { className: "flex h-screen flex-col overflow-hidden bg-black", children: [
      /* @__PURE__ */ jsxs(
        "header",
        {
          className: "flex h-12 flex-shrink-0 items-center justify-between bg-gray-900 px-4",
          style: { zIndex: 9999 },
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: () => setSelectedGameId(null),
                className: "rounded bg-gray-700 px-3 py-1.5 text-sm text-white hover:bg-gray-600",
                "aria-label": "Back",
                children: "← Back"
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-sm text-gray-300", children: title }),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: () => setIsSoundOn((v) => !v),
                className: `rounded px-3 py-1.5 text-sm ${isSoundOn ? "bg-green-600 text-white" : "bg-gray-700 text-gray-300"}`,
                "aria-label": isSoundOn ? "Mute" : "Unmute",
                "aria-pressed": isSoundOn,
                children: isSoundOn ? "🔊" : "🔇"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "relative flex-1 overflow-hidden", children: /* @__PURE__ */ jsx(
        GamePlayer,
        {
          gameKey: selectedGameId,
          user: testUser,
          api,
          isSoundOn,
          onClose: () => setSelectedGameId(null),
          loadingFallback: /* @__PURE__ */ jsx("div", { className: "flex h-full items-center justify-center text-white", children: "Loading…" })
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "p-6 mx-auto max-w-4xl space-y-6", children: [
    /* @__PURE__ */ jsx("h1", { className: "text-2xl font-bold text-gray-900", children: "Game Test Page" }),
    /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-600", children: "게임을 선택하여 테스트할 수 있습니다. 랭킹/점수 API 는 mock 으로 동작합니다." }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: games.map((game) => /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: () => setSelectedGameId(game.id),
        className: "flex flex-col overflow-hidden bg-white rounded-lg border border-gray-200 shadow-sm transition-shadow hover:shadow-md text-left",
        children: [
          /* @__PURE__ */ jsx("div", { className: "aspect-video bg-gray-100 overflow-hidden", children: /* @__PURE__ */ jsx(
            "img",
            {
              src: game.image,
              alt: game.ko.name,
              className: "object-cover w-full h-full",
              onError: (e) => {
                e.target.style.display = "none";
              }
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: "p-4 space-y-1", children: [
            /* @__PURE__ */ jsx("h3", { className: "font-bold text-gray-900", children: game.ko.name }),
            /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-600", children: game.ko.desc }),
            /* @__PURE__ */ jsxs("div", { className: "flex gap-2 pt-1", children: [
              /* @__PURE__ */ jsx("span", { className: "px-2 py-0.5 text-xs bg-indigo-100 text-indigo-700 rounded", children: game.type }),
              game.junior && /* @__PURE__ */ jsx("span", { className: "px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded", children: "junior" }),
              game.mobile && /* @__PURE__ */ jsx("span", { className: "px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded", children: "mobile" })
            ] })
          ] })
        ]
      },
      game.id
    )) })
  ] });
}
export {
  GameTestPage
};
//# sourceMappingURL=GameTestPage.js.map
